<template>
  <ViewWrapper class="upgrade" :scrollable="true">
    <div class="upgrade__inner">
      <h2 class="upgrade__headline">{{ $t('status.upgrade.headline') }}</h2>
      <p>{{ $t('status.upgrade.copy') }}</p>
      <p class="upgrade__subline">
        {{ $t('status.upgrade.subline') }}
      </p>
    </div>
  </ViewWrapper>
</template>

<script>
import ViewWrapper from '../components/ViewWrapper';

export default {
  name: 'Upgrade',

  components: {
    ViewWrapper,
  },
};
</script>

<style lang="scss" scoped>
.upgrade {
  background-color: rgba($color-black, $view-overlay-alpha-dark);
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.upgrade__inner {
  max-width: 320px;
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;

  p {
    line-height: 26px;
    margin-bottom: 40px;
  }
}

.upgrade__headline {
  font-size: 35px;
  margin-bottom: 20px;
  font-weight: bold;
}

.upgrade__subline {
  font-size: 11px;
  opacity: 0.5;
}
</style>
